module.exports = __webpack_public_path__ + "static/img/p24.99dc9c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p24.png
// module id = 83
// module chunks = 1